export const pct = (x: number | null | undefined, digits = 0): string => (x == null ? '—' : `${(x * 100).toFixed(digits)}%`);

export const fixed = (x: number | null | undefined, digits = 3): string => (x == null ? '—' : x.toFixed(digits));

/** 퍼센트포인트 차이 (예: 확신 평균 − 적중률) */
export const signedPct = (x: number): string => `${x >= 0 ? '+' : ''}${Math.round(x * 100)}%p`;

/** 상대 개선율 (예: 기술 점수 1 − BS/BS기준) */
export const signedRel = (x: number): string => `${x >= 0 ? '+' : ''}${Math.round(x * 100)}%`;

/** 표본이 모자랄 때 지표 아래에 붙이는 문구 */
export const pending = (n: number, min: number, unit: string): string => `판단 보류 (${n}/${min}${unit})`;

const trim = (x: number, d: number) => x.toFixed(d).replace(/\.0$/, '');

/** 초 → '10분', '3일', '2.5개월' */
export function duration(sec: number): string {
  const s = Math.abs(sec);
  if (s < 60) return `${Math.round(s)}초`;
  if (s < 3600) return `${Math.round(s / 60)}분`;
  if (s < 86400) return `${trim(s / 3600, s < 36000 ? 1 : 0)}시간`;
  const days = s / 86400;
  if (days < 30) return `${Math.round(days)}일`;
  if (days < 365) return `${trim(days / 30, 1)}개월`;
  return `${trim(days / 365, 1)}년`;
}

/** 복습 예정 시각 → '지금', '3일 후', '2일 밀림' */
export function dueLabel(iso: string | null | undefined): string {
  if (!iso) return '—';
  const diff = (new Date(iso).getTime() - Date.now()) / 1000;
  if (diff <= 60) return diff < -86400 ? `${duration(diff)} 밀림` : '지금';
  return `${duration(diff)} 후`;
}

/** 지난 시각 → '방금', '5분 전', '3시간 전', '2일 전' */
export function agoLabel(iso: string): string {
  const sec = (Date.now() - new Date(iso).getTime()) / 1000;
  if (sec < 60) return '방금';
  if (sec < 3600) return `${Math.floor(sec / 60)}분 전`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}시간 전`;
  return `${Math.floor(sec / 86400)}일 전`;
}

export function dateLabel(s: string | null | undefined): string {
  if (!s) return '—';
  const d = s.length === 10 ? new Date(`${s}T00:00:00`) : new Date(s);
  const md = `${d.getMonth() + 1}월 ${d.getDate()}일`;
  return d.getFullYear() === new Date().getFullYear() ? md : `${d.getFullYear()}년 ${md}`;
}

export const shortDate = (s: string): string => {
  const [, m, d] = s.slice(0, 10).split('-');
  return `${Number(m)}/${Number(d)}`;
};

export function dday(daysLeft: number): string {
  if (daysLeft > 0) return `D-${daysLeft}`;
  if (daysLeft === 0) return 'D-day';
  return `${-daysLeft}일 지남`;
}

export function localDate(offsetDays = 0): string {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export const clampPct = (x: number): number => Math.min(99, Math.max(1, Math.round(Number.isFinite(x) ? x : 50)));

export const errorMessage = (e: unknown): string => (e instanceof Error ? e.message : String(e));
